export default "__VITE_PUBLIC_ASSET__655d5ae7__"